import * as yup from 'yup';

export const ChangePasswordSchema = yup.object({
  oldPassword: yup.string().trim().required(),
  newPassword: yup.string().trim().required(),
  confirmPassword: yup
    .string()
    .trim()
    .required()
    .oneOf([yup.ref('newPassword'), ''], 'Passwords must match')
});

export type ChangePasswordSchemaType = yup.InferType<typeof ChangePasswordSchema>;
